export default __webpack_public_path__ + "static/media/E-WEB-Goal-02.610a1339.png";